<script setup>
const props = defineProps({
  placeholder: {
    type: String,
    default: ''
  },
  maxLength: {
    type: Number,
    default: 200
  },
  resize: Boolean,
  help: {
    type: String,
    default: ''
  },
  dir: {
    type: String,
    default: 'auto'
  },
  rows: {
    type: Number,
    default: 3
  }
});

const inputVal = defineModel({
  type: String,
  default: ''
});

const isReachedMaxLength = computed(() => inputVal.value?.length === props.maxLength);

const formattedCharacterCount = computed(() => {
  const length = inputVal.value?.length || '';
  return `${length >= 10 ? '' : '0'}${length}/${props.maxLength}`;
});

const checkMaxLength = (event) => {
  const input = event.target;
  if (input.value?.length > props.maxLength) {
    input.value = input.value.slice(0, props.maxLength);
    inputVal.value = input.value;
  }
};
</script>

<template>
  <div class="relative">
    <UTextarea v-model="inputVal" :dir="dir" :resize="resize" :placeholder="placeholder" :rows="rows" @input="checkMaxLength" />
    <div class="absolute ltr:right-2 rtl:left-2 bottom-[2px] text-xs text-stone-grey bg-white rounded px-1 select-none" :class="{ 'text-sky-blue': isReachedMaxLength }">{{ formattedCharacterCount }}</div>
  </div>
</template>
